import { instance } from '../lib/api'
import Constants from '../utils/CommonConstants'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from './loading'
import getKeySearchPromises from '../utils/getKeySearchPromises'

export const API_FAIL = 'API_FAIL'
export const RAM_LIST = 'RAM_LIST'
export const CITY_LIST = 'CITY_LIST'
export const AGENT_LIST = 'AGENT_LIST'
export const GET_LIST_SEARCH = 'GET_LIST_SEARCH'
export const EXCEL_URL_FOR_SEARCH = 'EXCEL_URL_FOR_SEARCH'
export const CLEAR_EXCEL_URL = 'CLEAR_EXCEL_URL'
export const MASS_UPDATE_SUCCESS = 'MASS_UPDATE_SUCCESS'
export const DOWNLOAD_EXCEL_REQUEST_SUCCESS = 'DOWNLOAD_EXCEL_REQUEST_SUCCESS'

const addChild = (agents, child) => {
  agents[`${child.userName} - ${child.userId}`] = {
    id: child.userId,
    name: child.userName
  }
  if (child.child) {
    child.child.forEach(c => {
      agents = addChild(agents, c)
    })
  }
  return agents
}

export const getCities = () => {
  return dispatch => {
    const url = '/api/v1/polygon/top/cities/list'
    return instance({
      url,
      method: 'get'
    })
      .then(response => {
        const data = response.data
        const cities = [],
          citiesIdNameMap = {}
        data.top_cities.forEach(city => {
          cities[city.name] = city.uuid
          citiesIdNameMap[city.uuid] = city.name
        })
        data.other_cities.forEach(city => {
          cities[city.name] = city.uuid
          citiesIdNameMap[city.uuid] = city.name
        })
        dispatch({
          type: CITY_LIST,
          citiesIdNameMap,
          cities
        })
      })
      .catch(() => {
        dispatch({
          type: 'API_FAIL'
        })
      })
  }
}

export const getRAM = text => {
  text = text.trim()

  const url = `api/v0/employee/predict?q=${text}&profile_type=BrokerSales`
  return dispatch => {
    if (!text) return
    instance({
      url,
      method: 'get'
    })
      .then(response => {
        const payload = {},
          data = response.data
        if (!data || data.length === 0) return
        data.forEach(element => {
          payload[element.email] = element
        })
        dispatch({
          type: RAM_LIST,
          payload
        })
      })
      .catch(() => {
        dispatch({
          type: 'API_FAIL'
        })
      })
  }
}

export const getAgents = () => {
  const url = '/madrox/app/v1/entity/user/child'
  return dispatch => {
    return instance({
      url,
      method: 'get'
    })
      .then(response => {
        const data = response.data.data
        const agents = addChild({}, data)
        dispatch({
          type: AGENT_LIST,
          agents
        })
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
  }
}

const addToFIQL = (fiqlFilter, key, value) => {
  const equal = {}
  equal[key] = value
  fiqlFilter.push({
    equal
  })
  return fiqlFilter
}

const addDateRangeFilter = (fiqlFilter = [], key, dateRange) => {
  const dates = {}
  dates.from = dateRange.start ? dateRange.start.valueOf() : 0
  dates.to = dateRange.end ? dateRange.end.valueOf() : new Date().getTime()
  const range = {}
  range[key] = dates
  fiqlFilter.push({ range })
  return fiqlFilter
}

export const getOrderList = filters => {
  const rows = filters.rows || Constants.pageSize
  const finalFilter = {
    team: true,
    caseSubTypeId: filters.orderType.caseSubTypeId,
    paging: { rows },
    key: 'BASED_ON_OUTER_FILTER'
  }
  if (filters.start) {
    finalFilter.paging.start = filters.start
  } else if (filters.rows) {
    finalFilter.paging.start = 0
  }
  let fiqlFilter = []
  let values = Object.keys(filters.selectedStatus)
  if (values.length) {
    //values = Object.keys(filters.selectedStatus);//.map(status => filters.selectedStatus[status]);
    fiqlFilter = addToFIQL(fiqlFilter, 'statusId', values)
  }
  if (filters.orderIds.length) {
    let key
    switch (filters.orderType.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER_ORDER:
        key = 'orderId'
        break
      case Constants.CaseSubTypeMap.BROKER.PAYMENTS:
      case Constants.CaseSubTypeMap.MAKAAN.PAYMENTS:
      case Constants.CaseSubTypeMap.OWNER.PAYMENTS:
        key = Constants.paymentSearchKeysObj.paymentsId
        break
      case Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS:
        key = filters.paymentKey
        break
      case Constants.CaseSubTypeMap.BROKER.TERMSHEET:
      case Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET:
      case Constants.CaseSubTypeMap.MAKAAN.TERMSHEET:
        key = 'termsheetNumber'
        break
    }
    fiqlFilter = addToFIQL(fiqlFilter, key, filters.orderIds)
  }
  if (Object.keys(filters.selectedRams).length) {
    values = Object.keys(filters.selectedRams).map(
      ram => filters.selectedRams[ram].id
    )
    fiqlFilter = addToFIQL(fiqlFilter, 'ramId', values)
  }
  if (Object.keys(filters.selectedAgents).length) {
    values = Object.keys(filters.selectedAgents).map(
      agent => filters.selectedAgents[agent].id
    )
    fiqlFilter = addToFIQL(fiqlFilter, 'agentId', values)
  }
  if (Object.keys(filters.selectedCities).length) {
    values = Object.keys(filters.selectedCities).map(
      city => filters.selectedCities[city]
    )
    fiqlFilter = addToFIQL(fiqlFilter, 'cityId', values)
  }
  if (filters.createdAt.start || filters.createdAt.end) {
    fiqlFilter = addDateRangeFilter(fiqlFilter, 'createdAt', filters.createdAt)
  }
  if (filters.updatedAt.start || filters.updatedAt.end) {
    fiqlFilter = addDateRangeFilter(fiqlFilter, 'updatedAt', filters.updatedAt)
  }
  finalFilter.filters = { and: fiqlFilter }
  const promise = getKeySearchPromises(
    Constants.keySearchUrlsMap[filters.orderType.caseSubType],
    JSON.stringify([finalFilter])
  )
  return dispatch => {
    return promise
      .then(response => {
        dispatch({
          type: GET_LIST_SEARCH,
          data: response && response[0]
        })
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
  }
}

export const getExcelUrlForSearch = (filters, totalCount) => {
  const rows = totalCount
  const finalFilter = {
    team: true,
    caseSubTypeId: filters.orderType.caseSubTypeId,
    paging: { rows },
    key: 'BASED_ON_OUTER_FILTER'
  }
  if (filters.start) {
    finalFilter.paging.start = 0
  }
  let fiqlFilter = []
  let values = Object.keys(filters.selectedStatus)
  if (values.length) {
    /* values = Object.keys(filters.selectedStatus).map((status) => {
      return filters.selectedStatus[status];
    }); */
    fiqlFilter = addToFIQL(fiqlFilter, 'statusId', values)
  }
  if (filters.orderIds.length) {
    let key
    switch (filters.orderType.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER_ORDER:
        key = 'orderId'
        break
      case Constants.CaseSubTypeMap.BROKER.PAYMENTS:
        key = Constants.paymentSearchKeysObj.paymentsId
        break
      case Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS:
        key = filters.paymentKey
        break
      case Constants.CaseSubTypeMap.BROKER.TERMSHEET:
      case Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET:
        key = 'termsheetNumber'
        break
    }
    fiqlFilter = addToFIQL(fiqlFilter, key, filters.orderIds)
    //fiqlFilter = addToFIQL(fiqlFilter, 'orderId', filters.orderIds);
  }
  if (Object.keys(filters.selectedRams).length) {
    values = Object.keys(filters.selectedRams).map(ram => {
      return filters.selectedRams[ram].id
    })
    fiqlFilter = addToFIQL(fiqlFilter, 'ramId', values)
  }
  if (Object.keys(filters.selectedAgents).length) {
    values = Object.keys(filters.selectedAgents).map(agent => {
      return filters.selectedAgents[agent].id
    })
    fiqlFilter = addToFIQL(fiqlFilter, 'agentId', values)
  }
  if (Object.keys(filters.selectedCities).length) {
    values = Object.keys(filters.selectedCities).map(city => {
      return filters.selectedCities[city]
    })
    /**Excel download wasn't accepting cityId as key*/
    fiqlFilter = addToFIQL(fiqlFilter, 'city', values)
  }
  if (filters.createdAt.start || filters.createdAt.end) {
    fiqlFilter = addDateRangeFilter(fiqlFilter, 'createdAt', filters.createdAt)
  }
  if (filters.updatedAt.start || filters.updatedAt.end) {
    fiqlFilter = addDateRangeFilter(fiqlFilter, 'updatedAt', filters.updatedAt)
  }
  finalFilter.filters = { and: fiqlFilter }
  const excelUrlForSearch = `/mystique/rcm/v1/housing-developer-payments/key-search/rcm-payments.csv?rcmSelectorsArray=${JSON.stringify(finalFilter)}`
  return dispatch => {
    dispatch({
      type: EXCEL_URL_FOR_SEARCH,
      excelUrlForSearch
    })
  }
}

export const massUpdate = ({ assigneeAgent, rcmOrderIds, caseSubTypeId }) => {
  return dispatch => {
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: `Assigning ${rcmOrderIds.length} orders to ${assigneeAgent.name}.`
    })
    instance({
      method: 'POST',
      url: '/mystique/rcm/v1/mass-update',
      data: {
        rcmOrderIds,
        assigneeAgentId: assigneeAgent.id,
        caseSubTypeId
      }
    })
      .then(() => {
        dispatch({
          type: MASS_UPDATE_SUCCESS
        })
      })
      .catch(err => {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Some error occured.'
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const downloadExcelRequest = url => {
  return dispatch => {
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Sending excel download request'
    })
    instance({
      method: 'GET',
      url
    })
      .then(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_REQUEST_SUCCESS
        })
      })
      .catch(err => {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Error: sending excel download request.'
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/search.js
 **/